import styled from "styled-components";
import { blue } from "./Colors";

export const PseudoLink = styled.div`
  color: ${blue.bright};
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
`;
